import axios from "axios";

const instance = axios.create({
  baseURL: "https://api-prod-dot-pay-routeline.uc.r.appspot.com/api/v1", // prod
  // baseURL: "https://pay-routeline.uc.r.appspot.com/api/v1", // dev
  // baseURL: "http://localhost:3000/api/v1" // local
});

export default instance;
